module.exports = __webpack_public_path__ + "static/chloe-the-engineer-5b0cb82c776935f4357879b56589af47.jpg";